// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckLabel_root__39yE8","disabled":"CheckLabel_disabled__3jg0p"};